export function enrichEsimOffer(offer, brands = {}) {
  const rawBrand = offer.brandName || offer.brand || "eSIM";
  const brandKey = String(rawBrand).trim().toLowerCase();
  const brandData = brands?.[brandKey];

  const rawPriceMinor =
    (typeof offer.price === "number" ? offer.price : null) ??
    (typeof offer?.price?.fixed === "number" ? offer.price.fixed : null) ??
    (typeof offer?.raw?.price?.fixed === "number" ? offer.raw.price.fixed : null) ??
    null;

  const currency = String(
    offer.priceCurrency ||
      offer?.price?.currency ||
      offer.raw?.price?.currency ||
      "USD"
  ).toUpperCase();

  const divisor = Math.max(
    1,
    Number(
      offer.priceCurrencyDivisor ??
        offer?.price?.currencyDivisor ??
        offer.raw?.price?.currencyDivisor ??
        100
    ) || 1
  );

  const hasPrice = Number.isFinite(rawPriceMinor) && rawPriceMinor > 0;
  const priceValue = hasPrice ? rawPriceMinor / divisor : null;

  const requiredFields = Array.from(
    new Set(
      Array.isArray(offer.requiredFields) && offer.requiredFields.length
        ? offer.requiredFields
        : ["recipient.email"]
    )
  );

  const dataUnlimited = !!offer.dataUnlimited;
  const dataGB = Number(offer.dataGB ?? 0);
  const validityDays = offer.durationDays ?? null;

  const fixedType = offer.priceType || offer.pricingType || "FIXED";

  return {
    ...offer,
    type: "esim",
    productType: "ESIM",

    brand: brandKey,
    brandName: brandData?.brandName || rawBrand,
    image: brandData?.image || null,

    price: hasPrice ? rawPriceMinor : null,
    priceCurrency: currency,
    priceCurrencyDivisor: hasPrice ? divisor : null,
    priceValue,
    priceUSD: currency === "USD" && Number.isFinite(priceValue) ? priceValue : null,
    priceDisplay: hasPrice && Number.isFinite(priceValue) ? priceValue.toFixed(2) : "N/A",

    priceType: fixedType,
    pricingType: fixedType,

    variableAmount: false,
    fxBased: false,
    allowCustomAmount: false,

    durationDays: validityDays,
    duration: validityDays,
    dataGB,
    dataUnlimited,
    data: dataUnlimited ? "Unlimited" : `${dataGB} GB`,

    shortNotes: offer.shortNotes || offer.raw?.shortNotes || null,
    notes: offer.notes || offer.raw?.notes || null,

    requiredFields,
  };
}
